var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzWaterproof(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 8v61H53v-4h16V12H53V8h20zM28 43.76a10 10 0 0020 0c0-6.86-8.12-13.9-10-21.76-1.88 7.86-10 14.9-10 21.76zM3 69h20v-4H7V12h16V8H3v61z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Waterproof.dc160b76.svg";
export { SvgBzWaterproof as ReactComponent };